
export default {
  name: 'CarouselItems',
  functional: true,
  props: {
    discontinuedProduct: {
      type: Boolean,
      default: false
    }
  },
  render(createElement, {children, props, parent}) {
    if (!children || !children.length) {
      return createElement('div', {
        class: 'no-carousel-items'
      });
    }
    return children.map((child) =>
      createElement(
        'div',
        {
          class: 'carousel-item'
        },
        [
          props.discontinuedProduct
            ? createElement('div', {class: 'discontinued-info'}, [
                parent.$t('itemDiscontinued')
              ])
            : null,
          child
        ]
      )
    );
  }
};
